angular.module('rjmNg.services').factory 'remoteDBConnectionService', [
  "$http"
  "$resource"
  "app"
  "$url"
  "$q"
  ($http, $resource, app, $url, $q) ->
    _localTables = {}

    resource = $resource($url("/client/#{app.getClientId()}/remoteDBConnection/:connectionId/db/:databaseName/schema/:schemaName/table/:tableName/columns/"))

    fetch: (clientId=app.getClientId()) ->
      deferred = $q.defer()
      promise = $http
        method: "GET"
        url: $url("/client/#{clientId}/remoteDBConnection")
        cache: true
      .then ({data}) ->
        _localTables = {}

        for notused_key, connection of data.rsConnections
          for notused_key, database of connection.rsDatabases
            for notused_key, schema of database.rsSchemas
              for notused_key, table of schema.rsTables
                if not schema.name
                  table.schema = "emptySchema"
                  table.fullName = table.name
                else
                  table.schema = schema.name
                  table.fullName = table.schema + "." + table.name
                table.connectionId = connection.id
                table.databaseName = database.name
                if table.id?
                  _localTables[+table.id] = table

        deferred.resolve(data)
      .catch () ->
        deferred.reject()
      return deferred.promise

    invalidateLocalTableCache: (id) ->
      delete _localTables[+id]

    addLocalTable: (table) ->
      _localTables[+table.id] = table

    localTables: () ->
      return _localTables

    # Looks through a list of columns and returns the fist valid loalTableId it finds
    getLocalTableId: (columns) ->
      for column in columns
        if column.localTableId? and +column.localTableId isnt 0
          return column.localTableId
      return 0

    save: (lsTableId, columns, clientId=app.getClientId(), tableRowCount = null, totalTrackedRows = null, ignoreDependencies = false, dropTable = false, preview = false, isView = false) ->
      data =
        columns: columns
        tableRowCount: tableRowCount
        totalTrackedRows: totalTrackedRows
        ignoreDependencies: ignoreDependencies
        dropTable: dropTable
        preview: preview
        isView: isView

      $http(
        method: 'POST',
        url: $url("/client/#{clientId}/remoteDBConnection/#{lsTableId}")
        data: data
      )

    queryTable: (connectionId, databaseName, schemaName, tableName) ->
      resource.get(
        connectionId: connectionId
        databaseName: databaseName
        schemaName: schemaName
        tableName: encodeURIComponent(tableName)
      ).$promise.then (data) ->

        data.columns = _(data.columns).map (remoteStructure, name) ->
          remoteStructure.name = name
          remoteStructure.isKey = !!remoteStructure.isKey
          remoteStructure.isTracked = !!remoteStructure.isTracked
          return remoteStructure

        return data

]
